import {IArenaViewModel} from "../arena-view-model.interface";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import React from "react";
import {OrbitSuspense} from "../../../../../components/base-components/orbit-suspense/orbit-suspense";
import {NewLiveCasinoArenaComponent} from "../../../../../components/arena-host/new-live-casino-arena/new-live-casino-arena.component";

export class NewLiveCasinoArenaModel implements IArenaViewModel {
    constructor(public readonly arenaName: string,
                private readonly services: IServiceFactoryExtended) {
    }

    get listsCount(): number {
        return 0;
    }

    renderList(listPosition: number): React.ReactElement | null {
        return null;
    }

    getNextBatchSize(currentListPosition: number): number {
        return 0;
    }

    renderArena(): React.ReactElement | null {
        return (
            <OrbitSuspense>
                <NewLiveCasinoArenaComponent key={this.arenaName}
                                             arenaName={this.arenaName}
                                             configs={this.services.configuration.data.arenas[this.arenaName]}/>
            </OrbitSuspense>
        );
    }
}